import { render, staticRenderFns, recyclableRender, components } from "./load-refresh.vue?vue&type=template&id=2cb7ba04&scoped=true&"
var renderjs
import script from "./load-refresh.vue?vue&type=script&lang=js&"
export * from "./load-refresh.vue?vue&type=script&lang=js&"
import style0 from "./load-refresh.vue?vue&type=style&index=0&id=2cb7ba04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_@dcloudio_vue-cli-plugin-uni@2.0.0-28320200727001@@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb7ba04",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/load-refresh/load-refresh.vue"
export default component.exports